import gql from 'graphql-tag'

export const ADD_CVPOINT = gql`
mutation(
  $point:Int
  $employerId:ID
  $type:String
){
      addCVPoint(info:{
          point:$point
          employerId:$employerId
          type:$type
      })
  }

`
export const ADD_EMPLOYER = gql`
mutation (
	$name: String
	$email: String
	$password: String
	$logo: String
	$companyName: String!
	$aboutCompany: String!
	$industryId: [ID]!
	$companySizeId: ID
	$website: String!
	$facebook: String!
	$nortificationEmails: [String]
	$appliedEmails: [String]
	$notifyExpire: [String]
	$village: String
	$districtId: ID!
	$country: String!
	$phone: String
	$Profile: String
  $featureProfile:String
  $isFeature: Boolean
	$Gallerys: [String]
	$Peoples: [peopleInput]
	$Benefits: [benefits]
	$companyColor: String
  $textColor:String
	$isLink: String
	$youtube: String
	$titok:String
	$twitter:String
	$linkIn:String
	$pService: [pServiceInput]
	$lng: Any
	$lat: Any
  $videoLink:String
  $cardCover:String
) {
	addEmployer(
		info: {
			name: $name
			email: $email
			password: $password
			logo: $logo
			companyName: $companyName
			aboutCompany: $aboutCompany
			industryId: $industryId
			companySizeId: $companySizeId
			website: $website
			facebook: $facebook
			nortificationEmails: $nortificationEmails
			appliedEmails: $appliedEmails
			notifyExpire: $notifyExpire
			village: $village
			districtId: $districtId
			country: $country
			phone: $phone
			Profile: $Profile
			Gallerys: $Gallerys
			Peoples: $Peoples
			Benefits: $Benefits
      featureProfile:$featureProfile
			companyColor: $companyColor
      textColor: $textColor
      isFeature:$isFeature
			isLink: $isLink
			youtube: $youtube
			titok:$titok
			twitter:$twitter
			linkIn:$linkIn
			pService: $pService
			lng: $lng
			lat: $lat
      videoLink:$videoLink
      cardCover:$cardCover
		}
	) {
		userId
		name
		email
		empId
		companyName
		aboutCompany
	}
}

`
export const GET_STAFF = gql`
query(
  $UserId:ID 
){
  getStaff(UserId:$UserId){
    UserId
    name
    email
    role
  }
}
`
export const GET_STAF = gql`
query(
  $id:ID
){
  editUser(id:$id){
    _id
    name
    email
    role
  }
}
`
export const UPDATE_STAFF = gql`
mutation(
  $id:ID
  $name: String
  $email: String
  $role: String
){
  updatestaffs(info:{
    id:$id 
    name:$name
    email: $email
    role:$role
  }){
    _id 
    name
    email
  }
}

`
export const ADD_STAFF = gql`
mutation(
  $userId: ID
$name: String
  $email: String
  $password: String
  $role:String
){
  addStaff(info:{
    userId:$userId
    name:$name 
    email: $email
    password: $password
    role:$role
  }){
    _id
    staffID
    name
    email 
    role
  }
}
`
export const GET_EMPLOYER = gql`
query(
  $type: String!,
  $page: Int!,
  $perPage: Int!,
  $search: String
)
{
  getEmployer(type:$type page:$page perPage:$perPage search:$search) {
    employers{
      userId
      empId
      logo
      companyName
      owner
      email
      point
      status
      cvPoints
      blacklist
  }
    totals
  }
}

`
export const UPDATE_EMPLOYER = gql`
mutation(
  $employerId: ID!
  $logo:String
  $companyName:String!
  $aboutCompany:String!
  $companyColor:String
  $textColor:String
  $featureProfile:String
  $industryId:[ID]!
  $companySizeId:ID
  $website:String!
   $facebook: String!
   $nortificationEmails: [String] 
   $appliedEmails: [String] 
   $notifyExpire: [String]
  $districtId:ID
   $village: String
    $country: String!
    $phone: String
  $isFeature: Boolean
  $Profile:String,
  $Gallerys:[String],
  $Peoples:[peopleInput],
  $Benefits:[benefits]
  $isLink:String
  $UserId: [ID]
	$youtube: String
	$titok:String
	$twitter:String
	$linkIn:String
  $pService:[pServiceInput]
  $lng:Any
  $lat:Any
  $videoLink:String
  $cardCover:String
)
{
  updateEmployer 
  (
          info: {
                employerId:$employerId
                logo:$logo
                companyName: $companyName
                aboutCompany: $aboutCompany
                companyColor: $companyColor
                textColor: $textColor
                featureProfile: $featureProfile
                industryId: $industryId
                companySizeId: $companySizeId
                website: $website
                facebook: $facebook
                nortificationEmails:$nortificationEmails
                appliedEmails:$appliedEmails
                notifyExpire:$notifyExpire
                 districtId:$districtId
                village: $village
                country: $country
                phone: $phone
                isFeature:$isFeature
                Profile:$Profile
                Gallerys:$Gallerys
                Peoples:$Peoples
                Benefits:$Benefits
                youtube: $youtube
                titok:$titok
                twitter:$twitter
                linkIn:$linkIn
                pService:$pService
                lng:$lng
                lat:$lat
                isLink:$isLink
                UserId:$UserId
                videoLink:$videoLink
                cardCover:$cardCover
          } 
  ){
     _id
    Profile
    logo 
    companyName
    aboutCompany
    companyColor
    textColor
    industryId {
      _id
      name
    }
    companySizeId {
      _id
      name
    }
    website
    facebook
    nortificationEmails
    appliedEmails
    notifyExpire
    village
    districtId {
      _id
      name
    }
    country
    phone
    status
    Gallerys
    Peoples{
      image
      name
      position
      duty
    }
    Benefits{
      image
      details
    }
    isLink
    isFeature
    UserId{
      _id
      fName
    }
    cardCover
  }
 
}
`
export const APPROVED = gql`
mutation(
  $employerId: ID!
){
  approvedemployer(
    employerId:$employerId
  )

}
`
export const REJECT = gql`
mutation(
  $employerId: ID!
){
  rejectedEmployer(
    employerId:$employerId
  )

}
`
export const RESET = gql`
mutation(
  $email:String!
){
  emailVerify(email:$email)
}

`
export const Approved = gql`
mutation(
  $_id:ID
){
  unlockYellow(_id:$_id)
}

`
